/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CreditFacilityBorrowingBaseGroupCreateAPIDataRequest
} from '../../model/creditFacilityBorrowingBaseGroupCreateAPIDataRequest'
import type {
  CreditFacilityBorrowingBaseGroupData
} from '../../model/creditFacilityBorrowingBaseGroupData'
import type {
  CreditFacilityBorrowingBaseGroupDataList
} from '../../model/creditFacilityBorrowingBaseGroupDataList'
import type {
  CreditFacilityBorrowingBaseGroupDeleteParams
} from '../../model/creditFacilityBorrowingBaseGroupDeleteParams'
import type {
  CreditFacilityBorrowingBaseGroupListParams
} from '../../model/creditFacilityBorrowingBaseGroupListParams'
import type {
  CreditFacilityBorrowingBaseGroupUpsertDataRequest
} from '../../model/creditFacilityBorrowingBaseGroupUpsertDataRequest'
import type {
  CreditFacilityBorrowingBaseGroupWithCountDataList
} from '../../model/creditFacilityBorrowingBaseGroupWithCountDataList'
import type {
  CreditFacilityBorrowingBaseGroupsUpsertParams
} from '../../model/creditFacilityBorrowingBaseGroupsUpsertParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Lists credit facility borrowing base groups for a credit facility.
 */
export const creditFacilityBorrowingBaseGroupList = (
    fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityBorrowingBaseGroupListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityBorrowingBaseGroupWithCountDataList>(
      {url: `/fund-family/${fundFamilyId}/credit-facility-borrowing-base-group/${creditFacilityId}/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreditFacilityBorrowingBaseGroupListQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityBorrowingBaseGroupListParams,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility-borrowing-base-group/${creditFacilityId}/`, ...(params ? [params]: [])] as const;
    }

    
export const getCreditFacilityBorrowingBaseGroupListQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityBorrowingBaseGroupListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityBorrowingBaseGroupListQueryKey(fundFamilyId,creditFacilityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>> = ({ signal }) => creditFacilityBorrowingBaseGroupList(fundFamilyId,creditFacilityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityBorrowingBaseGroupListQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>>
export type CreditFacilityBorrowingBaseGroupListQueryError = unknown

export const useCreditFacilityBorrowingBaseGroupList = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityBorrowingBaseGroupListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityBorrowingBaseGroupListQueryOptions(fundFamilyId,creditFacilityId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityBorrowingBaseGroupListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityBorrowingBaseGroupListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityBorrowingBaseGroupListQueryKey(fundFamilyId,creditFacilityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>> = ({ signal }) => creditFacilityBorrowingBaseGroupList(fundFamilyId,creditFacilityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityBorrowingBaseGroupListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>>
export type CreditFacilityBorrowingBaseGroupListSuspenseQueryError = unknown

export const useCreditFacilityBorrowingBaseGroupListSuspense = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    params?: CreditFacilityBorrowingBaseGroupListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityBorrowingBaseGroupListSuspenseQueryOptions(fundFamilyId,creditFacilityId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityBorrowingBaseGroupListLoader = (queryParamsOrFn?: (CreditFacilityBorrowingBaseGroupListParams | ((params: Params) => CreditFacilityBorrowingBaseGroupListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && creditFacilityId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityBorrowingBaseGroupListQueryKey(fundFamilyId,creditFacilityId, queryParams),
              queryFn: () => creditFacilityBorrowingBaseGroupList(fundFamilyId,creditFacilityId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts credit facility borrowing base groups for a credit facility.
 */
export const creditFacilityBorrowingBaseGroupsUpsert = (
    fundFamilyId: string,
    creditFacilityId: string,
    creditFacilityBorrowingBaseGroupCreateAPIDataRequest: CreditFacilityBorrowingBaseGroupCreateAPIDataRequest,
    params?: CreditFacilityBorrowingBaseGroupsUpsertParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CreditFacilityBorrowingBaseGroupDataList>(
      {url: `/fund-family/${fundFamilyId}/credit-facility-borrowing-base-group/${creditFacilityId}/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityBorrowingBaseGroupCreateAPIDataRequest,
        params
    },
      options);
    }
  


export const getCreditFacilityBorrowingBaseGroupsUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupsUpsert>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityBorrowingBaseGroupCreateAPIDataRequest;params?: CreditFacilityBorrowingBaseGroupsUpsertParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupsUpsert>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityBorrowingBaseGroupCreateAPIDataRequest;params?: CreditFacilityBorrowingBaseGroupsUpsertParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupsUpsert>>, {fundFamilyId: string;creditFacilityId: string;data: CreditFacilityBorrowingBaseGroupCreateAPIDataRequest;params?: CreditFacilityBorrowingBaseGroupsUpsertParams}> = (props) => {
          const {fundFamilyId,creditFacilityId,data,params} = props ?? {};

          return  creditFacilityBorrowingBaseGroupsUpsert(fundFamilyId,creditFacilityId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityBorrowingBaseGroupsUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupsUpsert>>>
    export type CreditFacilityBorrowingBaseGroupsUpsertMutationBody = CreditFacilityBorrowingBaseGroupCreateAPIDataRequest
    export type CreditFacilityBorrowingBaseGroupsUpsertMutationError = unknown

    export const useCreditFacilityBorrowingBaseGroupsUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupsUpsert>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityBorrowingBaseGroupCreateAPIDataRequest;params?: CreditFacilityBorrowingBaseGroupsUpsertParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityBorrowingBaseGroupsUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Upserts a single credit facility borrowing base group for a credit facility.
 */
export const creditFacilityBorrowingBaseGroupUpsert = (
    fundFamilyId: string,
    creditFacilityId: string,
    creditFacilityBorrowingBaseGroupUpsertDataRequest: CreditFacilityBorrowingBaseGroupUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CreditFacilityBorrowingBaseGroupData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility-borrowing-base-group/${creditFacilityId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: creditFacilityBorrowingBaseGroupUpsertDataRequest
    },
      options);
    }
  


export const getCreditFacilityBorrowingBaseGroupUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupUpsert>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityBorrowingBaseGroupUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupUpsert>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityBorrowingBaseGroupUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupUpsert>>, {fundFamilyId: string;creditFacilityId: string;data: CreditFacilityBorrowingBaseGroupUpsertDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,data} = props ?? {};

          return  creditFacilityBorrowingBaseGroupUpsert(fundFamilyId,creditFacilityId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityBorrowingBaseGroupUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupUpsert>>>
    export type CreditFacilityBorrowingBaseGroupUpsertMutationBody = CreditFacilityBorrowingBaseGroupUpsertDataRequest
    export type CreditFacilityBorrowingBaseGroupUpsertMutationError = unknown

    export const useCreditFacilityBorrowingBaseGroupUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupUpsert>>, TError,{fundFamilyId: string;creditFacilityId: string;data: CreditFacilityBorrowingBaseGroupUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityBorrowingBaseGroupUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes a specific credit facility borrowing base group
 */
export const creditFacilityBorrowingBaseGroupDelete = (
    fundFamilyId: string,
    creditFacilityId: string,
    params: CreditFacilityBorrowingBaseGroupDeleteParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/credit-facility-borrowing-base-group/${creditFacilityId}/`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getCreditFacilityBorrowingBaseGroupDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupDelete>>, TError,{fundFamilyId: string;creditFacilityId: string;params: CreditFacilityBorrowingBaseGroupDeleteParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupDelete>>, TError,{fundFamilyId: string;creditFacilityId: string;params: CreditFacilityBorrowingBaseGroupDeleteParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupDelete>>, {fundFamilyId: string;creditFacilityId: string;params: CreditFacilityBorrowingBaseGroupDeleteParams}> = (props) => {
          const {fundFamilyId,creditFacilityId,params} = props ?? {};

          return  creditFacilityBorrowingBaseGroupDelete(fundFamilyId,creditFacilityId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityBorrowingBaseGroupDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupDelete>>>
    
    export type CreditFacilityBorrowingBaseGroupDeleteMutationError = unknown

    export const useCreditFacilityBorrowingBaseGroupDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseGroupDelete>>, TError,{fundFamilyId: string;creditFacilityId: string;params: CreditFacilityBorrowingBaseGroupDeleteParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityBorrowingBaseGroupDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    